import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Compass, Search } from 'lucide-react';
import ContentGrid from '../components/common/ContentGrid';
import { demoPosts, demoArticles, demoVideos } from '../data/demoData';
import { useShare } from '../hooks/useShare';
import { CATEGORIES } from '../types';

export default function ExplorePage() {
  const { theme } = useTheme();
  const handleShare = useShare();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  // Combine all content
  const allContent = [...demoPosts, ...demoArticles, ...demoVideos];

  // Filter content based on search and category
  const filteredContent = allContent.filter(content => {
    const matchesSearch = searchQuery
      ? content.type === 'post'
        ? content.content.toLowerCase().includes(searchQuery.toLowerCase())
        : ('title' in content && content.title.toLowerCase().includes(searchQuery.toLowerCase()))
      : true;

    const matchesCategory = selectedCategory
      ? content.type === 'article' || content.type === 'video'
        ? content.category === selectedCategory
        : content.category.name === selectedCategory
      : true;

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Compass className="h-8 w-8 text-blue-500" />
          <h1 className={`text-2xl font-bold ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            Explore
          </h1>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Search content..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={`
              w-full px-4 py-2 pl-10 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
              ${theme === 'dark'
                ? 'bg-gray-800 border-gray-700 text-gray-100'
                : 'bg-white border-gray-200 text-gray-900'
              }
            `}
          />
          <Search className={`absolute left-3 top-2.5 h-5 w-5 ${
            theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
          }`} />
        </div>

        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className={`
            px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${theme === 'dark'
              ? 'bg-gray-800 border-gray-700 text-gray-100'
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
        >
          <option value="">All Categories</option>
          {CATEGORIES.map(category => (
            <option key={category.id} value={category.name}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      <ContentGrid
        items={filteredContent}
        onLike={(id) => {
          console.log('Liked content:', id);
        }}
        onShare={async (id) => {
          const content = filteredContent.find(item => item.id === id);
          if (content) {
            await handleShare(content);
          }
        }}
      />
    </div>
  );
}